import { render, staticRenderFns } from "./CustomCtaButton.vue?vue&type=template&id=524ae945&scoped=true&"
import script from "./CustomCtaButton.vue?vue&type=script&lang=js&"
export * from "./CustomCtaButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomCtaButton.vue?vue&type=style&index=0&id=524ae945&scoped=true&lang=css&"
import style1 from "./CustomCtaButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ae945",
  null
  
)

export default component.exports